import React, { useEffect, useState } from 'react';
import { FileText, Download, Calendar } from 'lucide-react';
import BaseLayout from '../../layouts/BaseLayout';
import { useApiHandler } from '../../utils/apiHandler';

const Documents = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiHandler = useApiHandler();

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await apiHandler.get('/employee/accessible-documents'); // Replace with your actual API endpoint
        setDocuments(response.data.documents || []); // Extract documents array from the response
      } catch (err) {
        setError(err.message || 'Error fetching documents.');
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  if (loading) {
    return (
      <BaseLayout>
        <div className="text-center py-6">
          <p className="text-gray-600">Loading documents...</p>
        </div>
      </BaseLayout>
    );
  }

  if (error) {
    return (
      <BaseLayout>
        <div className="text-center py-6">
          <p className="text-red-600">{error}</p>
        </div>
      </BaseLayout>
    );
  }

  return (
    <BaseLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Documents</h1>
            <p className="text-gray-600 mt-1">Access and download company documents</p>
          </div>
        </div>

        <div className="grid gap-4">
          {documents.map((doc) => (
            <div
              key={doc._id} // Use _id from the response data
              className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-3">
                    <FileText className="h-6 w-6 text-blue-600" />
                    <h3 className="text-lg font-semibold text-gray-900">{doc.documentTitle}</h3> {/* Use documentTitle from the response */}
                  </div>
                  <p className="mt-2 text-gray-600">Uploaded by: {doc.uploadedBy}</p> {/* Display admin name */}
                  <div className="mt-4 flex items-center space-x-4 text-sm text-gray-500">
                    <div className="flex items-center">
                      <Calendar className="h-4 w-4 mr-1" />
                      <span>{new Date(doc.createdAt).toLocaleDateString()}</span> {/* Format the createdAt date */}
                    </div>
                  </div>
                </div>

                <a
                  href={doc.downloadUrl} // Use downloadUrl for the download link
                  className="flex items-center space-x-1 text-blue-600 hover:text-blue-700"
                  target="_blank"
                  rel="noopener noreferrer"
                  download // Ensures the file is downloaded
                >
                  <Download className="h-5 w-5" />
                  <span>Download</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </BaseLayout>
  );
};

export default Documents;
